// Full page cart view - Product in Cart CART-01,CART-15 --start
{
  // Clear viewedProducts from sessionStorage on page load (refresh/reload)
  window.addEventListener('load', () => {
    sessionStorage.removeItem('viewedProducts');
  });

  function getProductCategory(name) {
    if (!name) return 'Classic';
    if (name.includes('Experience')) return 'Experience';
    if (name.includes('Pocket')) return 'Pocket';
    return 'Classic';
  }

  // Helper: check if product has been viewed already
  function hasProductBeenViewed(productId) {
    if (!productId) return false;
    const viewedProducts = JSON.parse(sessionStorage.getItem('viewedProducts') || '[]');
    return viewedProducts.includes(productId);
  }

  // Helper: mark product as viewed
  function markProductAsViewed(productId) {
    if (!productId) return;
    let viewedProducts = JSON.parse(sessionStorage.getItem('viewedProducts') || '[]');
    if (!viewedProducts.includes(productId)) {
      viewedProducts.push(productId);
      sessionStorage.setItem('viewedProducts', JSON.stringify(viewedProducts));
    }
  }

  function trackProducts() {
    document.querySelectorAll('.line-item__content-wrapper:not([data-tracked])').forEach((item, index) => {
      let link = item.querySelector('a.line-item__image-wrapper');
      let titleLink = item.querySelector('.product-item-meta__title.hidden-phone');
      if (!link) return;

      let productVariant = link.dataset.productVariant || null;
      let productPrice = link.dataset.productPrice || null;
      let productId = link.dataset.productId || null;
      let productSku = link.dataset.productSku || null;
      let productQuantity = link.dataset.productQuantity || null;
      let productPosition = link.dataset.productPosition || link.getAttribute('data-product-index') || null;
      let productUpc = link.dataset.productUpc || null;
      let miniCartElement = link.closest('#mini-cart-form');
      let location = miniCartElement ? 'Cart Siderail - Main Cart' : 'Cart';
      const img = link.querySelector('img');

      if (img) {
        const productName = link.getAttribute('data-product-name') || null;
        const productCategory = getProductCategory(productName);
        const outboundUrl = link.href || "";
        const position = index + 1;

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!hasProductBeenViewed(productId)) {
                tagular('ProductViewed', {
                  product: {
                    brand: 'SHOP',
                    category: null,
                    coupon: null,
                    formatSubtype: null,
                    formatType: productVariant,
                    location: location,
                    name: productName,
                    pageId: null,
                    position: parseInt(productPosition),
                    price: parseFloat(productPrice),
                    productId: productId,
                    quantity: parseInt(productQuantity),
                    sku: productSku,
                    subscription: { frequency: null },
                    text: null,
                    upc: productUpc,
                    variant: productVariant,
                    positionEngine: null
                  }
                });
                markProductAsViewed(productId);
              }
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        observer.observe(img);

        const clickHandler = (e) => {
          tagular('ProductClicked', {
            actionOutcome: 'INTERNALLINK',
            correlationId: null,
            viewCorrelationId: null,
            listId: null,
            outboundUrl: outboundUrl,
            product: {
              brand: 'SHOP',
              category: null,
              coupon: null,
              formatSubtype: null,
              formatType: productVariant,
              location: 'Cart',
              name: productName,
              pageId: null,
              position: parseInt(productPosition),
              price: parseFloat(productPrice),
              productId: productId,
              quantity: parseInt(productQuantity),
              sku: productSku,
              subscription: { frequency: null },
              text: null,
              upc: productUpc,
              variant: productVariant,
              positionEngine: null
            }
          });
        };
        
        if (link) link.addEventListener('click', clickHandler);
        if (titleLink) titleLink.addEventListener('click', clickHandler);
        // Mark as tracked
        item.setAttribute('data-tracked', 'true');
      }
    });
  }

  // Initial run
  trackProducts();

  // Watch for future DOM changes
  const observer = new MutationObserver(() => {
    trackProducts();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Full page cart view - Product in Cart CART-01,CART-15 --end

// Full page cart view - Checkout button CART-09, --start
// {
//   let hasFired = false;

//   function observeCheckoutButtons() {
//     let cartCheckouts = document.querySelectorAll('.checkout-button');
//     if (cartCheckouts.length > 0) {
//       const observer = new IntersectionObserver((entries, observer) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting && !hasFired) {
//             hasFired = true;
//             observer.unobserve(entry.target);
//             let placement = entry.target.classList.contains('cart__checkout-button')? "Full Screen": "Side Rail";
//             tagular('FormViewed', {
//               correlationID: null,
//               captureContext: {
//                 capturePlacement: "Full Screen",
//                 captureType: "Flow",
//                 identityRequested: true
//               },
//               formContext: {
//                 formBrand: "LP Shop",
//                 formId: "CHKOUT-001",
//                 formName: "Checkout",
//                 formType: "Shop Purchase",
//                 formVersion: "v1"
//               }
//             });
//           }
//         });
//       }, {
//         threshold: 0.5
//       });
  
//       cartCheckouts.forEach(cartCheckout => {
//         observer.observe(cartCheckout);
//       });
//     }
//   }
  
//   observeCheckoutButtons();
  
//   const mutationObserver = new MutationObserver(() => {
//     observeCheckoutButtons();
//   });
  
//   mutationObserver.observe(document.body, {
//     childList: true, 
//     subtree: true 
//   });
  
// }

// Full page cart view - Checkout button CART-09,--end

// Full page cart view - Checkout button CART-09.01,CART-19.01 --start
{
  document.body.addEventListener('click', (e) => {
    if(e.target.closest('button')){
      if (e.target.classList.contains('checkout-button') || e.target.closest('button').classList.contains('checkout-button')) {
        let text = e.target.closest('button').textContent.trim();
        let location = e.target.closest('.mini-cart__drawer-footer')?'Cart Siderail':'Cart';
        let url = e.target.closest('.mini-cart__drawer-footer')?'https://shop.lonelyplanet.com/cart': null;
        tagular('ElementClicked',{       
          actionOutcome: 'INTERNALLINK',
          outboundUrl: null,
          webElement: {
            elementType: 'Button',
            htmlId: null,
            location: location,
            name: 'Checkout',
            position: null,
            text: text,
            variant: null
          }
        })
      }
    }
  })
}
// Full page cart view - Checkout button CART-09.01,CART-19.01 --end

// Full page cart view - Cart recs ATC button CART-07 --start
let recommendationsMain = document.querySelector(".js-addto-cart");

if (recommendationsMain) {

  setTimeout(() => {
    recommendationsMain.querySelectorAll("product-payment-container").forEach((item, index) => {
      let button = item.querySelector('button[type="submit"]');
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();

          const product = button.closest('.product-item');
          if (product) {
            const productName = product.querySelector('.product-item-meta__title')?.innerText.trim() || null;

            const priceEle = product.querySelector('.price');
            const priceMatch = priceEle?.textContent.match(/[\d,]+\.\d{2}/);
            const productPrice = priceMatch ? parseFloat(priceMatch[0].replace(/,/g, '')) : 0;
            const buttonPosition = parseInt(product.getAttribute('data-product-index')) || null;
            const variantEl = product.querySelector('.combo-box__option-item[aria-selected="true"]');
            const variant = variantEl?.dataset.title || null;
            const variantId = variantEl?.getAttribute('value') || null;

            let sku = null;
            let upc = null;
            const tagularJson = product.querySelector('script[tagular-data]');
            if (tagularJson) {
              try {
                const data = JSON.parse(tagularJson.textContent);
                if (data && variantId && data[variantId]) {
                  sku = data[variantId].sku || null;
                  upc = data[variantId].barcode || null;
                } else {
                  sku = data[Object.keys(data)[0]].sku || null;
                  upc = data[Object.keys(data)[0]].barcode || null
                }
              } catch (e) {
                console.warn('Invalid Tagular JSON data');
              }
            }

            tagular('ProductClicked', {
              actionOutcome: 'Added to Cart',
              correlationId: null, 
              viewCorrelationId: null,
              listId: null,
              outboundUrl: null,
              product: {
                brand: 'SHOP',
                category: null,
                coupon: null,
                formatSubtype: null,
                formatType: variant,
                location: "Cart - Recs",
                name: productName,
                pageId: null, 
                position: buttonPosition,
                price: productPrice,
                productId: null,
                quantity: 1,
                sku,
                subscription: {
                  frequency: null
                },
                text: null,
                upc,
                variant,
                positionEngine: null
              }
            });
            let form = product.querySelector("form");
            if (form) form.submit();
          }
        });
      }
    });
  }, 2000);
}

// Full page cart view - Cart recs ATC button CART-07 --end


// Full page cart view -"Remove" text option CART-03 --start

{
  let removeButtons = document.querySelectorAll('.line-item__remove-button');
  removeButtons.forEach((item)=>{
    item.addEventListener("click",(e)=>{
      // e.preventDefault();
      minusRemoveEvent(e);
    })
  })
  // let minusButtons = document.querySelectorAll('.quantity-selector__button');
  // minusButtons.forEach(button =>{
  //   let link = button.href;
  //   if (link.includes('quantity=0')) {
  //     button.addEventListener('click',(e)=>{
  //       minusRemoveEvent(e);
  //     })
  //   }
  // })

  function minusRemoveEvent(e) {
    let actionElement = e.currentTarget.getAttribute('aria-label');
    let productElement = e.currentTarget.closest('.line-item__content-wrapper') || e.currentTarget.closest('.line-item');
  
    if (!productElement) {
      console.warn("Product element not found");
      return;
    }
  
    let product = productElement.querySelector('.line-item__image-wrapper');
    if (!product) {
      console.warn("Product image wrapper not found");
      return;
    }
  
    let productId = product.dataset.productId;
    let productSku = product.dataset.productSku;
    let productUpc = product.dataset.productUpc;
    let productVariant = product.dataset.productVariant;
    let productName = product.dataset.productName;
    let productPosition = product.dataset.productIndex || product.getAttribute('data-product-position');
    let location = product.closest('#mini-cart-form')?'Cart Siderail - Main Cart':'Cart';
    let priceEle = productElement.querySelector('.price');
    let priceMatch = priceEle?.textContent?.match(/[\d,]+\.\d{2}/);
    let price = priceMatch ? priceMatch[0] : "0.00";
    let productPrice = parseFloat(price.replace(/,/g, "")) || null;
    let productQuantity = product.getAttribute('data-product-quantity') || null;
    let actionOutcome = actionElement === "Increase quantity" ? "Added to Cart" : "Removed from Cart";
  
    tagular('ProductClicked', {
      actionOutcome: actionOutcome,
      correlationId: null,
      viewCorrelationId: null,
      listId: null,
      outboundUrl: null,
      product: {
        brand: 'SHOP',
        category: null,
        coupon: null,
        formatSubtype: null,
        formatType: productVariant,
        location: location,
        name: productName,
        pageId: null,
        position: parseInt(productPosition),
        price: productPrice,
        productId: productId,
        quantity: parseInt(productQuantity),
        sku: productSku,
        subscription: {
          frequency: null
        },
        text: null,
        upc: productUpc,
        variant: productVariant,
        positionEngine: null
      }
    });
  }
}

// Full page cart view -"Remove" text option CART-03 --end

// Full page cart view - Checkout button CART-10 --start
// {
//   document.body.addEventListener('click', (e) => {
//     if (e.target && e.target.classList.contains('checkout-button')) {
//       tagular('FormStarted', {
//         correlationID: null,
//         captureContext: {
//           capturePlacement: "Full Screen",
//           captureType: "Flow",
//           identityRequested: true
//         },
//         // ValueProp: "Cart",
//         formContext: {
//           formBrand: "LP Shop",
//           formId: "CHKOUT-001",
//           formName: "Checkout",
//           formType: "Shop Purchase",
//           formVersion: "v1"
//         },
//         stepContext: {
//           stepId: null,
//           stepName: "Checkout Initiation",
//           stepNumber: 0
//         }
//       });
//     }
//   });
// }
// Full page cart view - Checkout button CART-10 --end
